import React from 'react';
import { dropdown_options, dropdown, dropdownPage1 } from '../partnerStyles';
import { logEvent } from '../services/Analytics';

// TODO:Account for translations
const DropdownMenu = props => {
  let extraDivStyle = {};

  if (props.extraStyle) {
    extraDivStyle = props.extraStyle;
  }

  const options = props.s.map(x => {
    return (
      <div
        className="s"
        onClick={() => {
          logEvent(props.category, props.action2, x);
          props.k(props.name, x);
        }}
        style={{ ...dropdown_options }}
      >
        <div>{x}</div>
      </div>
    );
  });
  let classAdd = '';
  if (props.showScrollBar) classAdd += 'showScrollbar ';
  return (
    <div
      className={'noselect ' + classAdd}
      style={
        props.page
          ? { ...dropdownPage1, ...extraDivStyle }
          : { ...dropdown, ...extraDivStyle }
      }
    >
      <span>{options}</span>
    </div>
  );
};

export default DropdownMenu;
